import {FC, useState, useEffect, Fragment} from 'react'

import {Col, Dropdown, Form, Pagination, Row, Table} from 'react-bootstrap'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import usePagination from 'utils/hooks/usePagination'

const api = new Api()

type Props = {
  refreshTable: boolean
}
const TableDataContent: FC<Props> = ({refreshTable}) => {
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [data, setData] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const paginator: any = usePagination({
    totalCount: data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    if (refreshTable) {
      fetchData()
    }
  }, [refreshTable])

  useEffect(() => {
    fetchData()
  }, [query, pagination.per_page, pagination.page])

  const fetchData = () => {
    setLoading(true)
    api
      .getLogChangeStatus({
        ...query,
        page: pagination.page,
        sort_field: 'created_at',
        per_page: pagination.per_page,
      })
      .then((response: any) => {
        setLoading(false)
        const data = response.data
        setData(data.data.logs)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  return (
    <>
      <Row>
        <Col md={{span: 4}}>
          <Form.Control
            placeholder='Cari...'
            name='q'
            onChange={(e) => {
              setPagination({...pagination, per_page: pagination.per_page, page: 1})
              setQuery({...query, q: e.target.value})
            }}
          />
        </Col>
        <Col md={{span: 2}}>
          <Form.Select
            aria-label='Default select example'
            className='mr-8'
            onChange={(e) => {
              setQuery({...query, sort_order: e.target.value})
            }}
          >
            <option value='desc'>Terbaru</option>
            <option value='asc'>Terlama</option>
          </Form.Select>
        </Col>
      </Row>{' '}
      <Row md={12} className='mt-8'>
        <Table responsive className='table-striped align-middle'>
          <thead>
            <tr>
              <th>#</th>
              <th>Nama</th>
              <th>Jenis Penilaian</th>
              <th>Tanggal</th>
              <th>Dari Status</th>
              <th>Ke Status</th>
              <th>Catatan</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.map((item: any, key: any) => (
              <tr key={key}>
                <td>{(pagination?.page - 1) * pagination?.per_page + key + 1}</td>
                <td>{item?.nama}</td>
                <td>{item?.jenis_penilaian}</td>
                <td>{item?.tanggal}</td>
                <td>{item?.dari_status}</td>
                <td>{item?.ke_status}</td>
                <td>{item?.catatan}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Row>
      <Row>
        <Col md={6}>
          {data?.data?.length > 0 && !loading && (
            <div style={{float: 'left'}}>
              <Dropdown>
                <Dropdown.Toggle className='btn btn-sm'>{pagination.per_page}</Dropdown.Toggle>
                <Dropdown.Menu>
                  {[10, 25, 50, 100].map((item: any) => (
                    <Dropdown.Item
                      key={item}
                      href='#/action-1'
                      onClick={() => onChangePerPage(item)}
                      disabled={pagination.per_page === item}
                    >
                      {item}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </Col>
        <Col md={6}>
          <div style={{float: 'right'}}>
            {!loading && (
              <Pagination className='btn-sm'>
                {paginator?.map((item: any) => {
                  return (
                    <Pagination.Item
                      className='btn-sm'
                      key={item}
                      active={item === pagination.page}
                      onClick={() => onChangePerPage(pagination.per_page, item)}
                      disabled={item === '...'}
                    >
                      {item}
                    </Pagination.Item>
                  )
                })}
              </Pagination>
            )}
          </div>
        </Col>
      </Row>
    </>
  )
}

const TableData: FC<Props> = ({refreshTable}) => {
  return <TableDataContent refreshTable={refreshTable} />
}

export default TableData
